export default __webpack_public_path__ + "8694f4668c94cdc9d16e7d1b865da3b0.svg";